import { LoadingSpinner } from "@/components/ui/loadingSpinner";
import { useIsMobile } from "@/hooks/use-mobile";
import { useFetchData } from "@/hooks/useFetchData";
import { calculateFundingTotals } from "@/libs/utils";
import React, { useState } from "react";

const FundingSummary = ({ projectsByPp, carrier, devises }) => {
  const { fetchData } = useFetchData();
  const [totals, setTotals] = useState({
    obtained: 0,
    contributions: 0,
  });
  const isMobile = useIsMobile();
  const [loading, setLoading] = useState(false);
  React.useEffect(() => {
    (async () => {
      setLoading(true);

      if (!projectsByPp || Object.keys(projectsByPp).length === 0) {
        setLoading(false);
        return;
      }
      type Program = {
        projects: any[]; // ou un type spécifique au projet si tu l’as
      };
      const allProjects = Object.values(
        projectsByPp as Record<string, Program>
      ).flatMap((p) => p.projects || []);

      // Prépare les promesses SANS les await pour qu'elles s'exécutent en parallèle
      const fundingPromise = calculateFundingTotals(allProjects);
      const fetchReportPromise = fetchData(
        `${import.meta.env.VITE_API_ENDPOINT}/report/programs${
          carrier ? `?user=${carrier}&context=program` : "?context=program"
        }`
      );

      // On attend les deux résultats en parallèle
      const [fundingTotals, reportData] = await Promise.all([
        fundingPromise,
        fetchReportPromise,
      ]);

      // On déstructure le résultat de calculateFundingTotals
      const { totalObtained, callContributions } = fundingTotals;

      setTotals({
        obtained: totalObtained,
        contributions: callContributions,
      });
      setLoading(false);
    })();
  }, [projectsByPp, devises, carrier]);

  if (loading) {
    return <LoadingSpinner />;
  }
  return (
    <div className="md:w-[60%]">
      <h2 className="text-xl font-bold mb-3">Totaux des financements:</h2>
      <p className="text-sm text-foreground m-0 whitespace-nowrap flex w-full items-end gap-2">
        <span className="opacity-65">Contributions déjà</span>{" "}
        {isMobile && <br />}
        <span className="opacity-65">obtenu (CO)</span>
        <b className="text-primary text-right md:text-left flex-1">
          : {parseFloat(totals.obtained.toFixed(1)).toLocaleString("fr-FR")} €
        </b>
      </p>
      <div className="mb-1 flex gap-2 mt-3 md:mt-0">
        <p className="text-sm text-foreground m-0 whitespace-nowrap flex items-end gap-2 w-full">
          <span className="opacity-65">Appel à contributions</span>{" "}
          {isMobile && <br />}{" "}
          <b className="text-secondary text-right md:text-left flex-1">
            :{" "}
            {parseFloat(totals.contributions.toFixed(1)).toLocaleString(
              "fr-FR"
            )}{" "}
            €
          </b>
        </p>
      </div>
    </div>
  );
};

export default FundingSummary;
